<template>
  <v-app>
    <oly-header></oly-header>
    <v-content><router-view></router-view></v-content>
    <oly-footer></oly-footer>
    <basket-snackbar></basket-snackbar>
    <switch-customer
      v-if="$route.name !== 'switch_customer' && customerCount > 1"
    ></switch-customer>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { auth } from "@/firebase";
import OlyHeader from "@/components/OlyHeader.vue";
import OlyFooter from "@/components/OlyFooter.vue";
import BasketSnackbar from "@/components/BasketSnackbar.vue";
import SwitchCustomer from "@/components/SwitchCustomer.vue";

export default {
  components: {
    OlyHeader,
    OlyFooter,
    BasketSnackbar,
    SwitchCustomer
  },
  methods: {
    ...mapActions("admin", ["fetchIsMaintenance"])
  },
  computed: {
    ...mapGetters("user", { customerCount: "getCustomerCount" }),
    ...mapGetters("admin", { isMaintenance: "getIsMaintenance" })
  },
  watch: {
    $route: async function(to) {
      const isAuthenticated = auth.currentUser;
      const routeName = "maintenance";
      await this.fetchIsMaintenance();

      if (to.name != routeName && this.isMaintenance) {
        this.$router.push({ name: routeName });
      } else if (to.name == routeName && !this.isMaintenance) {
        this.$router.push({ name: isAuthenticated ? "home" : "login" });
      }
    }
  }
};
</script>
